import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let cities = useDataValue({
    context: 'cities',
    viewPath: props.viewPath,
  })
  let selectedId = useDataValue({
    context: 'city',
    path: 'id',
    viewPath: props.viewPath,
  })
  let setCity = useDataChange({
    context: 'contact_method_association',
    path: 'postal_address.city',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let selected = cities.find(item => item.id === selectedId)
    setCity(selected.value)
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
